import * as React from 'react'
import { ForwardedRef } from 'react'
import MuiAlert, { AlertProps } from '@mui/material/Alert'

const Alert = React.forwardRef((props: AlertProps, ref?: ForwardedRef<HTMLDivElement> | null) => {
  return <MuiAlert ref={ref} {...props} />
})

export default Alert
